import { ApiClient } from "@/utils/apiClient";
import type { ApiResponse } from "@/models/api";
import type { MembershipTier } from "@/models/membershipTier";

export type MembershipTiersGetResponse = ApiResponse<{
  membershipTiers: MembershipTier[];
}>;

export abstract class MembershipTierApiService {
  public static async get(): Promise<MembershipTiersGetResponse> {
    const response = await ApiClient.getClient().get<MembershipTiersGetResponse>('/membership-tiers');
    return response.data;
  }
}
